import { jsx as _jsx } from "react/jsx-runtime";
export function StatusDot({ tone, size = 8 }) {
    const c = { ok: 'var(--dot-ok)', warn: 'var(--dot-warn)', danger: 'var(--danger)', off: 'var(--dot-off)' }[tone];
    return _jsx("span", { "aria-hidden": true, style: { width: size, height: size, borderRadius: '50%', background: c, flex: 'none', display: 'inline-block' } });
}
//# sourceMappingURL=StatusDot.js.map